var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MhPre__boolean",class:_vm.data ? 'MhPre__boolean--isTrue' : 'MhPre__boolean--isFalse'},[(_vm.data === true)?_c('span',[_vm._v("true")]):_vm._e(),(_vm.data === false)?_c('span',[_vm._v("false")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }